<template>
  <div class="time-table-view">
    <aside>
      <ul>
        <li v-for="day in days" :key="day">
          <span>{{ day }}</span>
        </li>
      </ul>
    </aside>
    <section>
      <div>
        <header>
          <ul class="time-table-view-header-time">
            <li v-for="(_, i) in 25" :key="i">
              <span
                :style="`color: rgb(75, 85, 99); font-size: 16px; ${
                  i === 0
                    ? 'transform: translateX(0)'
                    : 'transform: translateX(-50%)'
                }`"
                >{{ i }}</span
              >
            </li>
          </ul>
        </header>
        <div class="time-table-view-content-container">
          <ul class="time-table-view-content-line">
            <li
              v-for="(_, i) in 8"
              :key="i"
              :style="i % 2 ? 'background-color: rgb(243, 244, 246);' : ''"
            >
              <span v-for="(_, i) in 49" :key="i" />
            </li>
          </ul>
          <ul class="time-table-view-content-body">
            <li v-for="(timeTable, i) in timeTableData" :key="i">
              <div
                v-for="(time, i) in timeTable.time_period"
                :key="i"
                class="tooltip"
              >
                <div
                  v-if="time"
                  class="time-table-view-content-body-item"
                  :style="`left: ${time.start}px; width: ${time.end}px;`"
                >
                  <span v-if="time" class="tooltip-text">
                    {{ time.time_period_start }} -
                    {{ time.time_period_end }}
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    timeTableData: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      days: [
        'อาทิตย์',
        'จันทร์',
        'อังคาร',
        'พุธ',
        'พฤหัส',
        'ศุกร์',
        'เสาร์',
        'วันหยุด',
      ],
    }
  },
}
</script>

<style lang="css" scoped>
.time-table-view {
  display: flex;
}

.time-table-view ul {
  list-style-type: none;
  padding: 0;
}

.time-table-view aside {
  margin-top: 32px;
  margin-right: 4px;
}
.time-table-view aside ul {
  width: 100px;
}
.time-table-view aside li {
  color: #111827;
  font-size: 16px;
  background-color: rgb(243, 244, 246);
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.time-table-view section {
  display: flex;
  overflow-x: auto;
}
.time-table-view-header-time {
  display: flex;
  align-items: center;
}
.time-table-view-header-time li {
  height: 32px;
  width: 44px;
  display: flex;
  align-items: center;
}

.time-table-view-content-container {
  position: relative;
  /* width: calc(100% - 48px);
  overflow: hidden; */
}

.time-table-view-content-line {
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
}

.time-table-view-content-line li {
  display: flex;
  height: 40px;
  margin-bottom: 2px;
}
.time-table-view-content-line li:last-child {
  margin-bottom: 0;
}
.time-table-view-content-line span {
  width: 22px;
  border-left: 1px solid rgb(229, 231, 235);
}

.time-table-view-content-body {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.time-table-view-content-body li {
  display: flex;
  height: 40px;
  margin-bottom: 2px;
  position: relative;
}
.time-table-view-content-body-item {
  position: absolute;
  top: 1px;
  bottom: -1px;
  background-color: rgba(21, 128, 61, 0.7);
}

.tooltip {
  position: relative;
  cursor: pointer;
}
.tooltip .tooltip-text {
  position: absolute;
  background-color: #424242;
  color: white;
  padding: 3px 10px;
  border-radius: 5px;
  z-index: 100;
  min-width: 105px;
  visibility: hidden;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
}
</style>
